import React from "react";
import {Link} from 'react-router-dom';

import Head from './head';
import Nav from './nav';
import Footer from './footer';
import Scripts from './scripts';
import './css/dorm-detail.css';
import './css/slideshow.css'
import './css/review.css'
import Reviews from "./reviews";
import {useEffect, useState} from "react";

import { storage } from "../firebase";
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import {v4} from 'uuid';
import {API_BASE} from "../apiConfig";

const LocationPin = () => (
	<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
		<path d="M10 18s6-5.5 6-10a6 6 0 10-12 0c0 4.5 6 10 6 10z"/>
		<circle cx="10" cy="8" r="2"/>
	</svg>
);

const FloorPlanIcon = () => (
	<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5">
		<rect x="2.5" y="2.5" width="15" height="15" rx="1"/>
		<path d="M2.5 9.5h15M9.5 2.5v15M2.5 6h4M13.5 13.5h4"/>
	</svg>
);

function FloorPlanGroup({title, floors}) {
	if (!floors || floors.length === 0) return null;
	return (
		<div className="floorplan-group">
			{title ? <h3 className="floorplan-group-title">{title}</h3> : null}
			<div className="floorplan-grid">
				{floors.map(({key, val}, idx) => (
					<button type="button" className="floorplan-card" key={idx} onClick={() => window.open(val, "_blank")}>
						<FloorPlanIcon/>
						Floor {key}
					</button>
				))}
			</div>
		</div>
	)
}

function DormListing () {
	// retrieve id (will be right after the last backslash
	let pathArray = window.location.pathname.split('/');
	let id = pathArray[pathArray.length - 1];
	// "loading" | "ready" | "error" - tracks the initial dorm-data fetch
	const [pageState, setPageState] = useState("loading");
	// retrieve all fields
	let [dormData, setDormData] = useState({})
	// data for general floor plan
	let [keysData, setKeysData] = useState([])
	let [valuesData, setValuesData] = useState([])
	// greg-specific floor plan
	let [gregAKeys, setGregAKeys] = useState([])
	let [gregAVals, setGregAVals] = useState([])
	let [gregBKeys, setGregBKeys] = useState([])
	let [gregBVals, setGregBVals] = useState([])
	// keeney-specific floor plan
	let [ABKeys, setABKeys] = useState([])
	let [ABVals, setABVals] = useState([])
	let [EPKeys, setEPKeys] = useState([])
	let [EPVals, setEPVals] = useState([])
	let [JMKeys, setJMKeys] = useState([])
	let [JMVals, setJMVals] = useState([])
	// youngo-specific floor plan
	let [YO2Keys, setYO2Keys] = useState([])
	let [YO2Vals, setYO2Vals] = useState([])
	let [YO4Keys, setYO4Keys] = useState([])
	let [YO4Vals, setYO4Vals] = useState([])
	let [YO10Keys, setYO10Keys] = useState([])
	let [YO10Vals, setYO10Vals] = useState([])
	// new pem-specific floor plan
	let [NP1Keys, setNP1Keys] = useState([])
	let [NP1Vals, setNP1Vals] = useState([])
	let [NP2Keys, setNP2Keys] = useState([])
	let [NP2Vals, setNP2Vals] = useState([])
	let [NP3Keys, setNP3Keys] = useState([])
	let [NP3Vals, setNP3Vals] = useState([])
	let [NP4Keys, setNP4Keys] = useState([])
	let [NP4Vals, setNP4Vals] = useState([])
	// grad-specific floor plan
	let [gradAKeys, setGradAKeys] = useState([])
	let [gradAVals, setGradAVals] = useState([])
	let [gradBKeys, setGradBKeys] = useState([])
	let [gradBVals, setGradBVals] = useState([])
	let [gradCKeys, setGradCKeys] = useState([])
	let [gradCVals, setGradCVals] = useState([])
	let [gradDKeys, setGradDKeys] = useState([])
	let [gradDVals, setGradDVals] = useState([])

	const fetchData = async () => {
		let data;
		try {
			const response = await fetch(`${API_BASE}/dorms/${id}`);
			if (!response.ok) throw new Error(`Request failed with status ${response.status}`);
			data = await response.json();
		} catch (error) {
			console.log("Error: Failed to fetch dorm data", error);
			setPageState("error");
			return;
		}
		setDormData(data)
		setPageState("ready")
		if (data.name === "Greg") {
			let keysA = await (Object.keys(data.floorA))
			setGregAKeys(keysA)
			let valuesA = await (Object.values(data.floorA))
			setGregAVals(valuesA)
			let keysB = await (Object.keys(data.floorB))
			setGregBKeys(keysB)
			let valuesB = await (Object.values(data.floorB))
			setGregBVals(valuesB)
		} else if (data.name === "Keeney") {
			let keysA = await (Object.keys(data.floorA))
			setABKeys(keysA)
			let valuesA = await (Object.values(data.floorA))
			setABVals(valuesA)
			let keysB = await (Object.keys(data.floorB))
			setEPKeys(keysB)
			let valuesB = await (Object.values(data.floorB))
			setEPVals(valuesB)
			let keysC = await (Object.keys(data.floorC))
			setJMKeys(keysC)
			let valuesC = await (Object.values(data.floorC))
			setJMVals(valuesC)
		} else if (data.name === "New Pembroke") {
			let keysA = await (Object.keys(data.floorA))
			setNP1Keys(keysA)
			let valuesA = await (Object.values(data.floorA))
			setNP1Vals(valuesA)
			let keysB = await (Object.keys(data.floorB))
			setNP2Keys(keysB)
			let valuesB = await (Object.values(data.floorB))
			setNP2Vals(valuesB)
			let keysC = await (Object.keys(data.floorC))
			setNP3Keys(keysC)
			let valuesC = await (Object.values(data.floorC))
			setNP3Vals(valuesC)
			let keysD = await (Object.keys(data.floorD))
			setNP4Keys(keysD)
			let valuesD = await (Object.values(data.floorD))
			setNP4Vals(valuesD)
		} else if (data.name === "Grad Center") {
			let keysA = await (Object.keys(data.floorA))
			setGradAKeys(keysA)
			let valuesA = await (Object.values(data.floorA))
			setGradAVals(valuesA)
			let keysB = await (Object.keys(data.floorB))
			setGradBKeys(keysB)
			let valuesB = await (Object.values(data.floorB))
			setGradBVals(valuesB)
			let keysC = await (Object.keys(data.floorC))
			setGradCKeys(keysC)
			let valuesC = await (Object.values(data.floorC))
			setGradCVals(valuesC)
			let keysD = await (Object.keys(data.floorD))
			setGradDKeys(keysD)
			let valuesD = await (Object.values(data.floorD))
			setGradDVals(valuesD)
		} else if (data.name === "Young Orchard") {
			let keysA = await (Object.keys(data.floorA))
			setYO2Keys(keysA)
			let valuesA = await (Object.values(data.floorA))
			setYO2Vals(valuesA)
			let keysB = await (Object.keys(data.floorB))
			setYO4Keys(keysB)
			let valuesB = await (Object.values(data.floorB))
			setYO4Vals(valuesB)
			let keysC = await (Object.keys(data.floorC))
			setYO10Keys(keysC)
			let valuesC = await (Object.values(data.floorC))
			setYO10Vals(valuesC)
		} else { // general floor plan
			let keys = await (Object.keys(data.floors))
			setKeysData(keys)
			let values = await (Object.values(data.floors))
			setValuesData(values)
		}
	}

	// .images is an integer representing the number of photos we have
	// generates the html elements for all images, to be inserted in html
	const length = dormData.images;
	const images = [];
	const thumbs = [];
	for (let i = 1; i < length + 1; i++) {
		const dir = require(`./img/inside/${id}/${i}.jpg`);
		images.push(
			<article key={`img-${i}`}>
				<div className="photo-frame">
					<div className="photo-bg" style={{backgroundImage: `url(${dir})`}}></div>
					<img className="photo-fg" src={dir} alt={`Room view ${i}`}/>
				</div>
			</article>
		);
		thumbs.push(<label htmlFor={`slide${i}`} className="thumb" key={`thumb-${i}`}><img src={dir} alt=""/></label>);
	}

	// generates the html elements for all image inputs, to be inserted in html
	const btns = [];
	for (let i = 2; i < length + 1; i++) {
		let slideId = `slide${i}`;
		btns.push(<input type="radio" name="slider" id={slideId} key={slideId}/>);
	}

	useEffect(() => {
		fetchData()
	}, [])

	//makes sure getComments is only called once upon page loading, wait it to make sure the dorm.name var is defined
	useEffect(() => {
		if(dormData.name) {
			getComments()
		}
	}, [dormData])

	//state variable for the page reviews - updated when user submits a new review
	const [revs, setRev] = useState([[]]); //state variable for the page reviews - updated when user submits a new review

	//state variables for user input form
	const [image, setImage] = useState(null);
	const [displayimg, setdisplayimg] = useState(null);
	const [rating, setRating] = useState(0);
	const [review, setRec] = useState("");
	const [hover, setHover] = useState(0); //hover used for star variable

	//when the page loads gets reviews for that dorm
	const getComments = async () => {
		let postParameters = {
			"dormName": dormData.name
		};

		await fetch(`${API_BASE}/getReview`, {
			method: 'post', body: JSON.stringify(postParameters),
			headers: {"Access-Control-Allow-Origin": "*"}
		}).then((responseObject) => {
			responseObject.json()
				.then((reviews) => {
					setRev(reviews['reviews'])
				}).catch((error: any) => console.log("Error: Failed to fetch table data to be broadcast", error))
		})
	}

	//post request to add new review to the database
	const updateReviews = async () => {
		const textarea = document.getElementById('mytextArea');
		const dormdropdown = document.getElementById('dorm-name-dropdown')
		var dorm = dormdropdown.options[dormdropdown.selectedIndex].text;

		const dormRev = textarea.value;
		const rat = rating;

		if(dorm === "Choose your Dorm" | rat === 0 | dormRev === "") {
			alert("review NOT added, please make sure a dorm name is choosen and both the rating and review" +
				" fields are filled out")
		} else if (displayimg != null){
			var imageRef = await ref(storage, `images/${image.value + v4()}`);
			const upload = uploadBytes(imageRef, image).then(() => {
				getDownloadURL(imageRef).then(function(url){
					setdisplayimg("")

					//make a method -- can't be called in here if image is not being uploaded
					let postParameters = {
						"dormName": dorm,
						"rating": rat,
						"review": dormRev,
						"image": url,
						"email": localStorage.getItem("email"),
						// image
					};

					//reset inner HTML of text area after form is submitted
					textarea.value = ""

					if (rating === 0 || review === "") {
						console.log("error")
					} else {
						fetch(`${API_BASE}/addReview`, {
							method: 'post', body: JSON.stringify(postParameters),
							headers: {"Access-Control-Allow-Origin": "*"}
						}).then(response => {
							response.json()
								.then((reviews) => {
									setRev(reviews['updatedReviews'])
									alert("review added")
								})
								.catch((error: any) => console.log("Error: Failed to fetch table data to be broadcast", error))
						})
					}
				})
			}) } else {
					//make a method -- can't be called in here if image is not being uploaded
					let postParameters = {
						"dormName": dorm,
						"rating": rat,
						"review": dormRev,
						"image": "",
						"email": localStorage.getItem("email"),
						// image
					};

			//reset inner HTML of text area after form is submitted
					textarea.value = ""

					if (rating === 0 || review === "") {
						console.log("error")
					} else {
						fetch(`${API_BASE}/addReview`, {
							method: 'post', body: JSON.stringify(postParameters),
							headers: {"Access-Control-Allow-Origin": "*"}
						}).then(response => {
							response.json()
								.then((reviews) => {
									setRev(reviews['updatedReviews'])
									alert("review added")
								})
								.catch((error: any) => console.log("Error: Failed to fetch table data to be broadcast", error))
						})
					}
				}
	}

	// funciton to show updated image to the screen when user uploads it
	const onImageChange = (event) => {
		if (event.target.files && event.target.files[0]) {
			setdisplayimg(URL.createObjectURL(event.target.files[0]));
		}
	}

	// depending on if the current dorm has multiple buildings, these build the groups of floor plans to display
	let floorPlanGroups = [];
	if (dormData.name === "Greg") {
		const gregKeys = [gregAKeys, gregBKeys]
		const gregVals = [gregAVals, gregBVals]
		const titles = ["Greg A", "Greg B"]
		floorPlanGroups = titles.map((title, i) => ({
			title,
			floors: gregKeys[i].map((key, j) => ({key, val: gregVals[i][j]}))
		}))
	} else if (dormData.name === "Keeney") {
		const keeneyKeys = [ABKeys, EPKeys, JMKeys]
		const keeneyVals = [ABVals, EPVals, JMVals]
		const titles = ["Archibald-Bronson", "Everett-Poland", "Jameson-Mead"]
		floorPlanGroups = titles.map((title, i) => ({
			title,
			floors: keeneyKeys[i].map((key, j) => ({key, val: keeneyVals[i][j]}))
		}))
	} else if (dormData.name === "New Pembroke") {
		const NPKeys = [NP1Keys, NP2Keys, NP3Keys, NP4Keys]
		const NPVals = [NP1Vals, NP2Vals, NP3Vals, NP4Vals]
		floorPlanGroups = NPKeys.map((keys, i) => ({
			title: `New Pembroke ${i + 1}`,
			floors: keys.map((key, j) => ({key, val: NPVals[i][j]}))
		}))
	} else if (dormData.name === "Grad Center") {
		const gradKeys = [gradAKeys, gradBKeys, gradCKeys, gradDKeys]
		const gradVals = [gradAVals, gradBVals, gradCVals, gradDVals]
		const titles = ["Grad Center A", "Grad Center B", "Grad Center C", "Grad Center D"]
		floorPlanGroups = titles.map((title, i) => ({
			title,
			floors: gradKeys[i].map((key, j) => ({key, val: gradVals[i][j]}))
		}))
	} else if (dormData.name === "Young Orchard") {
		const YOKeys = [YO2Keys, YO4Keys, YO10Keys]
		const YOVals = [YO2Vals, YO4Vals, YO10Vals]
		const titles = ["Young Orchard #2", "Young Orchard #4", "Young Orchard #10"]
		floorPlanGroups = titles.map((title, i) => ({
			title,
			floors: YOKeys[i].map((key, j) => ({key, val: YOVals[i][j]}))
		}))
	} else { // regular case, single building
		floorPlanGroups = [{
			title: null,
			floors: keysData.map((key, i) => ({key, val: valuesData[i]}))
		}]
	}

	// average rating computed from the reviews already loaded for this dorm
	const ratedReviews = revs.filter((r) => Array.isArray(r) && typeof r[2] === "number");
	const avgRating = ratedReviews.length ? ratedReviews.reduce((sum, r) => sum + r[2], 0) / ratedReviews.length : 0;

	return (
		<div className="dorm">
			<Head/>
			<Nav/>

			<div className="detail-back">
				<Link to="/dorms">
					<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M12 4l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>
					All Dorms
				</Link>
			</div>

			{pageState === "loading" ? (
				<div className="page-loading">
					<div className="spinner"></div>
					<p>Loading dorm details&hellip;</p>
				</div>
			) : pageState === "error" ? (
				<div className="page-error">
					<p>Couldn't load this dorm's details right now.</p>
					<button type="button" className="btn-secondary retry-btn" onClick={fetchData}>Try again</button>
				</div>
			) : (
			<>
			<div className="detail-top">
				<div className="wrapper">
					<input defaultChecked type="radio" name="slider" id="slide1"/>
					{btns}
					<div className="slider-wrapper">
						<div className="inner">
							{images}
						</div>
					</div>
					<div className="thumbs">
						{thumbs}
					</div>
				</div>

				<div className="detail-info">
					{dormData.location ? <div className="location-line"><LocationPin/>{dormData.location}</div> : null}
					<h1>{dormData.name}</h1>
					<p className="description">{dormData.description}</p>

					<div className="feature-list">
						<div className="feature-row"><span className="f-label">Room Types</span><span className="f-value">{dormData.room?.join(", ")}</span></div>
						<div className="feature-row"><span className="f-label">Bathroom</span><span className="f-value">{dormData.bathroom}</span></div>
						<div className="feature-row"><span className="f-label">Kitchen</span><span className="f-value">{dormData.kitchen}</span></div>
						<div className="feature-row"><span className="f-label">Floor</span><span className="f-value">{dormData.carpet ? "Carpet" : "Hardwood/Tiled"}</span></div>
						<div className="feature-row"><span className="f-label">Common Room</span><span className="f-value">{dormData.common_room ? "Yes" : "No"}</span></div>
						<div className="feature-row"><span className="f-label">Elevator</span><span className="f-value">{dormData.elevator ? "Yes" : "No"}</span></div>
					</div>
				</div>
			</div>

			<div className="map-section">
				<h2>Location</h2>
				<div className="map-frame">
					<iframe
						title={`${dormData.name || "Dorm"} location map`}
						src={dormData.map}
						width="100%"
						height={320}
						frameBorder={0}
						style={{border: 0}}
						allowFullScreen=""
					/>
				</div>
			</div>

			<div className="floorplans-section">
				<h2>Floor Plans</h2>
				{floorPlanGroups.map((group, i) => <FloorPlanGroup key={i} {...group}/>)}
			</div>

			<div className="reviews-section">
				<div className="reviews-heading-row">
					<h2>Reviews</h2>
					{ratedReviews.length > 0 ? (
						<div className="rating-summary">
							<div className="star-rating read-only">
								{[...Array(5)].map((star, index) => {
									index += 1;
									return (
										<button type="button" key={index} className={index <= Math.round(avgRating) ? "on" : "off"}>
											<span>&#9733;</span>
										</button>
									);
								})}
							</div>
							<span className="rating-summary-text">{avgRating.toFixed(1)} &middot; {ratedReviews.length} review{ratedReviews.length !== 1 ? "s" : ""}</span>
						</div>
					) : null}
				</div>

				<div className="write-review">
					<h4>Write a review</h4>

					<div className="write-review-field">
						<div className="write-review-label">Your rating</div>
						<div className="star-rating">
							{[...Array(5)].map((star, index) => {
								index += 1;
								return (
									<button
										type="button"
										key={index}
										className={index <= (hover || rating) ? "on" : "off"}
										onClick={() => setRating(index)}
										onMouseEnter={() => setHover(index)}
										onMouseLeave={() => setHover(rating)}
									>
										<span>&#9733;</span>
									</button>
								);
							})}
						</div>
					</div>

					<div className="write-review-field">
						<div className="write-review-label">Dorm</div>
						<select className="form-control" id={"dorm-name-dropdown"} key={dormData.name || "loading"} defaultValue={dormData.name || ""} required="required">
							<option value="" disabled>Choose your Dorm</option>
							<option value="Morris">Morris</option>
							<option value="Champlin">Champlin</option>
							<option value="Emery">Emery</option>
							<option value="Woolley">Woolley</option>
							<option value="Andrews">Andrews</option>
							<option value="Metcalf">Metcalf</option>
							<option value="Miller">Miller</option>
							<option value="Wellness">Wellness</option>
							<option value="Slater">Slater</option>
							<option value="Hope">Hope</option>
							<option value="Hegeman">Hegeman</option>
							<option value="Littlefield">Littlefield</option>
							<option value="Barbour">Barbour</option>
							<option value="Wayland House">Wayland House</option>
							<option value="Minden">Minden</option>
							<option value="Goddard">Goddard</option>
							<option value="Buxton">Buxton</option>
							<option value="Olney">Olney</option>
							<option value="Harkness">Harkness</option>
							<option value="Chapin">Chapin</option>
							<option value="Diman">Diman</option>
							<option value="Sears">Sears</option>
							<option value="Marcy">Marcy</option>
							<option value="Caswell">Caswell</option>
							<option value="Greg">Greg</option>
							<option value="Keeney">Keeney</option>
							<option value="Grad Center">Grad Center</option>
							<option value="New Pembroke">New Pembroke</option>
							<option value="Young Orchard">Young Orchard</option>
							<option value="Perkins">Perkins</option>
						</select>
					</div>

					<div className="write-review-field">
						<div className="write-review-label">Your review</div>
						<textarea id="mytextArea" placeholder="Share what it's actually like living here..." onChange={setRec} required="required"></textarea>
					</div>

					{displayimg ? <img className="write-review-preview" src={displayimg} alt=""/> : null}

					<div className="write-review-actions">
						<label className="btn-secondary" htmlFor="file">
							<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2.5" y="5" width="15" height="12" rx="1.5"/><circle cx="10" cy="11" r="3"/><path d="M7 5l1-2h4l1 2"/></svg>
							Add photo
						</label>
						<input type="file" id="file" accept="image/*" onChange={(event) => {
							setImage(event.target.files[0]);
							onImageChange(event);
						}}/>
						<a className="btn-primary" href="#" onClick={updateReviews}>Post review</a>
					</div>
				</div>

				<Reviews reviewlst={revs}/>
			</div>
			</>
			)}

			<Footer/>
			<Scripts/>
		</div>
	)
}

export default DormListing;
